import { useEffect, useRef, useState } from "react";
import type { IVScoreResponse } from "../../types/market-data";
import {
  capLightStyle,
  directionPulseStyle,
  vixPulseStyle,
  type IvScoreStyle,
} from "./iv-score-visuals";

export function useIvScoreMotion(data: IVScoreResponse | null) {
  const previousVix = useRef<number | null>(null);
  const clearDirectionTimer = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const [direction, setDirection] = useState<"up" | "down" | null>(null);
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (!data) return;
    const current = data.vix.level;
    const previous = previousVix.current;
    if (previous !== null) {
      const delta = current - previous;
      if (Math.abs(delta) > 0.5) {
        setDirection(delta > 0 ? "up" : "down");
        if (clearDirectionTimer.current)
          clearTimeout(clearDirectionTimer.current);
        clearDirectionTimer.current = setTimeout(
          () => setDirection(null),
          3000,
        );
      }
      if (Math.abs(delta) > 0.01) {
        setFlash(true);
        window.setTimeout(() => setFlash(false), 150);
      }
    }
    previousVix.current = current;
  }, [data]);

  useEffect(
    () => () => {
      if (clearDirectionTimer.current)
        clearTimeout(clearDirectionTimer.current);
    },
    [],
  );

  const baseStyle = data ? vixPulseStyle(data.vix.level) : {};
  const valueStyle: IvScoreStyle = direction
    ? directionPulseStyle(direction)
    : baseStyle;
  const source =
    valueStyle["--fintheon-directional-cap-light-source"] ??
    "var(--fintheon-low)";
  return { flash, valueStyle, capLight: capLightStyle(source) };
}
